/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */
import {MutationTree} from 'vuex';
import {
    UserDetailsInterface,
    UserSessionInterface,
    UserSessionStateInterface,
} from '@/store/modules/user-session/types';
import {Vue} from 'vue-property-decorator';

/**
 * User session mutations.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const mutations: MutationTree<UserSessionStateInterface> = {
    /**
     * Logout of user session.
     *
     * @param {UserSessionStateInterface} state
     */
    logout(state: UserSessionStateInterface): void {
        Vue.set(state.session, 'token', '');
        Vue.set(state.session, 'refresh', '');
        Vue.set(state.session, 'expiry', 0);
        Vue.set(state, 'userDetails', undefined);
    },


    /**
     * Authenticate user session.
     *
     * @param {UserSessionStateInterface} state
     * @param {UserSessionInterface} session
     */
    authenticate(state: UserSessionStateInterface, session: UserSessionInterface): void {
        Vue.set(state.session, 'token', session.token || '');
        Vue.set(state.session, 'refresh', session.refresh || '');
        Vue.set(state.session, 'expiry', session.expiry || 0);
        Vue.set(state.session, 'verifier', session.verifier || '');
    },

    /**
     * Authenticate user session.
     * @param state
     * @param token
     */
    setToken(state: UserSessionStateInterface, token: string): void {
        Vue.set(state.session, 'token', token);
    },

    /**
     * Set the user details.
     *
     * @param {UserSessionStateInterface} state
     * @param {UserDetailsInterface} userDetails
     */
    userDetails(state: UserSessionStateInterface, userDetails: UserDetailsInterface): void {
        Vue.set(state, 'userDetails', userDetails);
        Vue.set(state, 'error', false);
    },

    /**
     * For the error in the user details.
     *
     * @param {UserSessionStateInterface} state
     *
     */
    userDetailsError(state: UserSessionStateInterface): void {
        Vue.set(state, 'error', true);
    },

    /**
     * Update the current view.
     *
     * @param {UserSessionStateInterface} state
     * @param {{name: string, param?: any} | undefined} view
     */
    updateCurrentView(state: UserSessionStateInterface, view: {name: string, param?: any} | undefined): void {
        Vue.set(state, 'currentView', view);
    },

};
